<template>
  <div class="">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LDropdownList',
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
</style>
